var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-content"},[_c('avue-crud',{attrs:{"data":_vm.tableData,"option":_vm.option,"table-loading":_vm.showLoading,"page":_vm.page},on:{"update:page":function($event){_vm.page=$event},"on-load":_vm.onLoad}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }